import Alert from '~/components/Alert';
import CardSection from '~/components/CardSection';
import Divide from '~/components/Divide';
import Form from '~/components/Form';
import Link from '~/components/Link';
import LoadingBoundary from '~/components/LoadingBoundary';
import { applicationTypes, imageTypes } from 'corso-types';
import Submit from '~/components/button/Submit';
import FileUploader from '~/components/form-controls/FileUploader';
import Page from '~/components/layout/page/Page';
import { useIsLoading } from '~/utils/routing';
import {
  AutomatedFormKeys,
  useActionResult,
  useLoaderData,
} from './registration';

const analyzingMessages = [
  'Extracting purchase details',
  'Locating customer details',
  'Matching retailer information',
  'Just a moment longer',
];

export default function RegistrationPage() {
  const isLoading = useIsLoading();
  const { uploadFileInfo, proofOfPurchaseAssets } = useLoaderData();
  const actionResult = useActionResult();

  return (
    <Page.Root title="Smart Registration">
      <LoadingBoundary
        isLoading={isLoading}
        loadingMessages={analyzingMessages}
        interval={3000}
      >
        <Divide>
          <div className="flex flex-col gap-4">
            <CardSection
              icon="CloudUploadSolid"
              title="Upload Your Receipt"
              description="Snap a photo or upload a receipt, invoice, or proof of purchase."
            />
            <CardSection
              icon="SparklesSolid"
              title="AI-Powered Analysis"
              description="We'll automatically extract your purchase details, identify products, and prefill your registration."
            />
          </div>

          <Form encType="multipart/form-data">
            <FileUploader
              label="Proof of Purchase"
              destination={uploadFileInfo.destination}
              storefrontId={uploadFileInfo.storefrontId}
              name={AutomatedFormKeys.Assets}
              defaultValue={proofOfPurchaseAssets}
              min={1}
              max={2}
              description="Upload a receipt, invoice, or other proof of purchase."
              accept={[...imageTypes, ...applicationTypes]}
            />

            {actionResult?.message && (
              <Alert variant="error" title={actionResult.message} />
            )}

            <Submit className="w-full" disabled={isLoading}>
              Analyze With AI
            </Submit>
          </Form>
        </Divide>

        <Link to="customer-info">No Proof of Purchase? Start Here</Link>
      </LoadingBoundary>
    </Page.Root>
  );
}
